import { Pressable, StyleSheet, View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';

import { CalendarIcon, InputErrors, Text, colors, spacing } from '@pletly/ui';

export const ScheduleButtonWeb = ({
	onPress,
	scheduleDate,
	disabled = false,
	errors = [],
	style,
	...viewProps
}: Props) => {
	const { t } = useTranslation();

	const text = scheduleDate
		? `${t('post.new.to-be-published')}: ${scheduleDate.toLocaleString()}`
		: t('post.new.schedule-for-later');

	const isValid = errors.length === 0;

	return (
		<View {...viewProps} style={[styles.root, style]}>
			<Pressable
				style={[styles.buttonContainer, !isValid && styles.errorBorder]}
				onPress={onPress}
				disabled={disabled}
			>
				<View style={styles.iconContainer}>
					<CalendarIcon />
				</View>

				<View style={styles.infoText}>
					<Text category="c2" numberOfLines={1}>
						{text}
					</Text>
				</View>
			</Pressable>
			{!isValid && <InputErrors errors={errors} />}
		</View>
	);
};

type Props = {
	onPress: () => void;
	scheduleDate?: Date | null;
	disabled?: boolean;
	errors?: string[];
} & ViewProps;

const styles = StyleSheet.create({
	root: {
		marginBottom: spacing(2),
	},
	buttonContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(),
		paddingHorizontal: spacing(2),
		paddingVertical: spacing(),
		backgroundColor: colors.neutral300,
		borderRadius: 8,
		alignSelf: 'flex-start',
		maxWidth: '100%',
	},
	infoText: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(0.5),
		flex: 1,
		minWidth: 75,
	},
	errorBorder: {
		borderColor: colors.accent,
		borderWidth: 1,
	},
	iconContainer: {
		width: 24,
		height: 24,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
